RivalIQ.module('utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    utils.color = {};

    const pie = [
        'x-default-theme-chart-color-one',
        'x-default-theme-chart-color-two',
        'x-default-theme-chart-color-three',
        'x-default-theme-chart-color-four',
        'x-default-theme-chart-color-five'
    ];
    const perDiem = [
        'x-default-theme-per-diem'
    ];

    const secondary = ['x-default-theme-chart-main-color'];
    const highlight = ['x-default-theme-chart-highlight-color'];

    const channel = [
        'twitter-bg',
        'facebook-bg',
        'linkedin-bg',
        null, // deprecated
        'youtube-bg',
        'instagram-bg',
        null, // deprecated
        null, // web
        null, // rivaliq
        null, // deprecated
        null, // cross-channel
        null, // facebook insights
        null, // deprecated
        null, // deprecated
        null, // deprecated
        null, // facebook boosted posts
        null, // facebook ads
        null, // deprecated
        null, // instagram insights
        null, // twitter insights
        'tiktok-bg'
    ];

    const exportFilter = function (defaultColors, brandColors) {
        let colors;

        const branding = RivalIQ.state.view.get('branding');
        if (branding) {
            colors = utils.branding.getBrandingColors(branding)[brandColors];
        } else {

            colors = _.map(RivalIQ.models.Brand.getColorsFromClassNames(defaultColors), function (itm) {
                return itm.color;
            });
        }

        return function (d, i) {
            return _.result(d, 'color') || colors[i % colors.length];
        };
    };

    utils.color.pie = function () {
        return exportFilter(pie, 'pie');
    };

    utils.color.donut = function () {
        const colors = _.map(RivalIQ.models.Brand.getColorsFromClassNames(pie), function (itm) {
            return itm.color;
        });

        return function (d, i) {
            return _.result(d, 'color') || colors[i % colors.length];
        };
    };

    utils.color.perDiem = function () {
        return exportFilter(perDiem, 'secondary');
    };

    utils.color.secondary = function () {
        return exportFilter(secondary, 'secondary');
    };

    utils.color.highlight = function (highlightTest) {

        return function () {
            const nonHighlightColors = exportFilter(secondary, 'secondary');
            const highlightColors = exportFilter(highlight, 'primary');

            return function (d, i) {
                return (highlightTest(d, i)) ? highlightColors(d, i) : nonHighlightColors(d, i);
            };
        };

    };

    utils.color.channel = function () {
        const colors = _.map(RivalIQ.models.Brand.getColorsFromClassNames(channel), 'color');
        return function (d) {
            return colors[Number(_.head(d.datum ? d.datum : d.data.datum))];
        };
    };
});
